import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import { Grid, GridItem } from 'components/UI/Grid';
import Link from 'components/UI/Link';
import LazyImage from 'components/UI/LazyImage';
import * as styles from './documents.module.scss';

export function Component({ content: { title, items }, className }) {
  return (
    <div className={cn(className, styles.wrapper)}>
      {title && (
        <Title tag="h4" className={styles.blockTitle}>
          {title}
        </Title>
      )}
      <Grid xsm={{ cols: 2 }} sm={{ cols: 2 }} md={{ cols: 2 }} lg={{ cols: 2 }} xl={{ cols: 3 }}>
        {items.map(({ name, icon, url }) => {
          return (
            <GridItem key={name}>
              <Link href={url} className={styles.link}>
                <span className={styles.title}>{name}</span>
                <LazyImage src={icon} alt={name} className={styles.icon} />
              </Link>
            </GridItem>
          );
        })}
      </Grid>
    </div>
  );
}
